export default "__VITE_ASSET__CKzUV78r__"